<template>
  <div>
   
    <auto-logout />
    <loader :loader="sending" />
    <div class="wrapper-content">
      <encabezado :elementos="encabezado" v-if="showAction(1)"/>
      <v-card v-if="showAction(1)">
      
        <v-card-text>
          <v-row align="baseline" justify="center" class="pb-4">
            <v-col>
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Buscar"
                single-line
                hide-details
                class="mx-5 mb-3"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="4" xl="2" sm="12">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    block
                    @click="changeAction(2)"
                    color="primary"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon left> mdi-plus </v-icon>
                    Nuevo personal
                  </v-btn>
                </template>
                <span>Agregar tipo de personal</span>
              </v-tooltip>
            </v-col>
          </v-row>
          <v-data-table
            :headers="headers"
            :items="list"
            :search="search"
            :items-per-page="10"
            :footer-props="{
              'items-per-page-text': 'Elementos por página',
              'items-per-page-all-text': 'Todo',
            }"
            no-results-text="Sin resultados coincidentes con el búsqueda"
            loading-text="Cargando..."
            no-data-text="Sin resultados disponibles"
            dense
            fixed-header
            height="auto"
          >
            <template v-slot:[`item.actions`]="{ item }">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn icon @click="get(item)">
                    <v-icon color="blue" v-bind="attrs" v-on="on">
                      mdi-pencil
                    </v-icon>
                  </v-btn>
                  {{ item.index }}
                </template>
                <span>Editar información</span>
              </v-tooltip>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
      <encabezado :elementos="encabezado" v-if="showAction(2) || showAction(3)"/>
      <v-card v-if="showAction(2) || showAction(3)">
        <validation-observer ref="form" v-slot="{ invalid }">
          <v-form @submit.prevent="doAction">
            <v-card-text>
              <v-row align="center" justify="center" class="d-flex flex-column">
                <v-col cols="12" md="6" xl="6">
                  <validation-provider
                    v-slot="{ errors }"
                    name="Nombre del personal"
                    rules="required|max:500"
                  >
                    <v-text-field
                      v-model="model.name"
                      :counter="500"
                      :maxlength="500"
                      :error-messages="errors"
                      label="Nombre del personal"
                      required
                      autocomplete="off"
                    ></v-text-field>
                  </validation-provider>
                </v-col>
                <v-col cols="12" md="6" xl="6">
                  <validation-provider
                    v-slot="{ errors }"
                    name="Acrónimo"
                    rules="required|max:15"
                  >
                    <v-text-field
                      v-model="model.acronym"
                      :counter="15"
                      :maxlength="15"
                      :error-messages="errors"
                      label="Acrónimo"
                      required
                      autocomplete="off"
                    ></v-text-field>
                  </validation-provider>
                </v-col>
              </v-row>
              <v-row align="center" justify="center">
                <v-col cols="12" md="1" xl="1">
                  <validation-provider v-slot="{ errors }" name="Firma">
                    <v-switch
                      v-model="model.requiresSignature"
                      inset
                      :error-messages="errors"
                    >
                      <template v-slot:label> Activar firma </template>
                    </v-switch>
                  </validation-provider>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions class="text-center">
              <v-col>
                <v-btn
                  type="submit"
                  plain
                  :disabled="sending"
                  color="error"
                  @click="changeAction(1)"
                >
                  <v-icon left> mdi-close </v-icon>
                  Cancelar
                </v-btn>
              </v-col>
              <v-col>
                <v-btn
                  type="submit"
                  :disabled="invalid || sending"
                  color="success"
                >
                  Guardar <v-icon right>{{ iconoAdd }}</v-icon>
                </v-btn>
              </v-col>
            </v-card-actions>
          </v-form>
        </validation-observer>
      </v-card>
    </div>
  </div>
</template>

<script>
import { ValidationObserver, ValidationProvider } from "vee-validate";
import Encabezado from "@/app/components/base/header/Header.vue";
import AutoLogout from "../../components/AutoLogout.vue";
import Loader from "../../components/Loader.vue";
import Sidebar from "../../components/Sidebar.vue";
import {
  PermissionRequest,
  ModuleRequest,
  PersonalTypeRequest,
} from "@/core/request";
import { UtilFront } from "@/core/";

export default {
  components: {
    Sidebar,
    AutoLogout,
    Loader,
    Encabezado,
    ValidationObserver,
    ValidationProvider,
    Notification,
    name: "Switch",
    inheritAttrs: false,
  },
  data() {
    return {
      sending: false,
      checked: true,
      dialog: false,
      index: -1,
      action: 1,
      list: [],
      model: {},
      iconoAdd: "mdi-content-save",
      service: PersonalTypeRequest,
      search: "",
      headers: [
        { text: "ID Personal", value: "idPersonalType" },
        { text: "Nombre", value: "name" },
        { text: "Acrónimo", value: "acronym" },
        { text: "Firma", value: "requiresSignature" },
        { text: "Acciones", value: "actions", sortable: false },
      ],
      encabezado: {
        icono: "mdi-pencil-circle-outline",
        texto: "Tipo de personal",
      },
    };
  },
  mounted() {
    this.listAll();
  },
  methods: {
    catchError: (e, x) => {
      UtilFront.errorhttp(e);
    },
    showAction(action) {
      return this.action == action;
    },
    changeAction(action) {
      if (action == 1) {
        this.$refs.form.reset();
        this.model = {};
        this.action = action;
        this.listAll();
      } else {
        this.action = action;
      }
    },
    doAction() {
      switch (this.action) {
        case 2:
          this.add();
          break;
        case 3:
          this.update();
          break;
      }
    },
    listAll() {
      this.sending = true;
      this.service
        .listAllPersonalType()
        .then((res) => {
          let { data, code, message } = res.data;
          if (code == 200) {
            this.list = data.map((objeto) => {
              objeto.requiresSignature =
                objeto.requiresSignature == 1 ? "Si" : "No";
              return objeto;
            });
          } else {
            this.list = [];
          }
        })
        .catch(this.catchError)
        .finally(() => {
          this.sending = false;
        });
    },
    add() {
      if(!this.sending){
      this.sending = true;
      this.model.requiresSignature =
        this.model.requiresSignature == true ? 1 : 0;
      this.service
        .addPersonalType(this.model)
        .then((res) => {
          let { data, response, message } = res.data;

          if (response) {
            //this.list.unshift(data);
            this.listAll();
            this.$utilFront.notifications(res.data.message, "SUCCESS");

            this.changeAction(1);
          } else {
            this.$utilFront.notifications(message, "ERROR");
          }
        })
        .catch(this.catchError)
        .finally(() => {
          this.sending = false;
        });
      }
    },
    update() {
      if(!this.sending){
      this.index = -1;
      this.sending = true;
      this.model.requiresSignature =
        this.model.requiresSignature == true ? 1 : 0;
      this.service
        .update(this.model)
        .then((res) => {
          let { response, message, data } = res.data;
          if (response) {
            this.list[this.index] = this.model.name;
            this.$utilFront.notifications("Personal actualizado", "SUCCESS");
            this.listAll();
            this.changeAction(1);
          } else {
            message = message || "Ocurrió un error durante la modificación.";
            this.$utilFront.notifications(message, "ERROR");
          }
        })
        .catch(this.catchError)
        .finally(() => {
          this.sending = false;
        });
      }
    },
    get(item, i) {
      item.requiresSignature = item.requiresSignature == "Si" ? 1 : 0;

      this.sending = true;
      let data = {};
      this.service
        .findPersonalType(item)
        .then((res) => {
          let { code, status, data } = res.data;
          if (code == 200) {
            this.model = data;

            this.index = Number(i);
            this.changeAction(3);
          } else {
            message = message || "Ocurrió un error al obtener la información.";
            this.$utilFront.notification("error", message);
          }
        })
        .catch(this.catchError)
        .finally(() => {
          this.sending = false;
        });
    },
  },
};
</script>
<style scoped>
.container {
  cursor: pointer;
  display: flex;
  align-items: center;
}
.label {
  margin-left: 12px;
  color: #1a202c;
}
.input {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
.switch {
  --switch-container-width: 50px;
  --switch-size: calc(var(--switch-container-width) / 2);
  /* Vertically center the inner circle */
  display: flex;
  align-items: center;
  position: relative;
  height: var(--switch-size);
  flex-basis: var(--switch-container-width);
  /* Make the container element rounded */
  border-radius: var(--switch-size);
  background-color: #8d939b;
  transition: background-color 0.25s ease-in-out;
}
.switch::before {
  content: "";
  transition: transform 0.375s ease-in-out;
  border: 2px solid var(--light-gray);
  position: absolute;
  /* Move a little bit the inner circle to the right */
  left: 1px;
  height: calc(var(--switch-size) - 4px);
  width: calc(var(--switch-size) - 4px);
  /* Make the inner circle fully rounded */
  border-radius: 9999px;
  background-color: white;
}
.input:checked + .switch {
  /* Teal background */
  background-color: #4fd1c5;
}
.input:checked + .switch::before {
  border-color: #4fd1c5;
  /* Move the inner circle to the right */
  transform: translateX(
    calc(var(--switch-container-width) - var(--switch-size))
  );
}
.input:focus + .switch::before {
  border-color: var(--dark-gray);
}
.input:focus:checked + .switch::before {
  border-color: var(--dark-teal);
}
</style>

